'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var _ = require('underscore');
var util = require('../../helper/util');

var PageControl = React.createClass({
  getInitialState : function(){
    return {
      selectedIndex : 3,
      canClick : false
    }
  },
  render : function(){
    return (<div className="component component-PageControl">
      <ul>
        {
          util.Util.map(5,function(o,i){
            return (<li key={i}/>)
          })
        }
      </ul>
    </div>);
  },

  componentDidMount : function(){
    var dom = ReactDOM.findDOMNode(this);
    var i;
    var li;
    dom = dom.children[0];
    for(i = 0;i<dom.children.length;i++) {
      li = dom.children[i];
      $(li).off('click');
      $(li).on('click', {index: i}, this.onItemClick)
    }
    this.doSelect();
  },

  componentDidUpdate : function(){
    this.doSelect();
  },

  onItemClick : function(e){
    var index = e.data.index;
    if(this.state.canClick){
      this.setState({selectedIndex:index});
    }
  },

  doSelect : function(){
    var dom = ReactDOM.findDOMNode(this);
    var i;
    var li;
    var bg;
    dom = dom.children[0];
    for(i = 0;i<dom.children.length;i++) {
      li = dom.children[i];
      if(i === this.state.selectedIndex){
        bg = '#41c7d6'
      }else{
        bg = '#ddd';
      }
      $(li).css({backgroundColor : bg})
    }
  }
});

module.exports = PageControl;



// WEBPACK FOOTER //
// ./src/views/Components/PageControl.jsx